import { Injectable } from '@angular/core';
import { ApiClient } from '@core/http/api-client';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AuthflowEnvelope, AuthflowResult } from './authflow.models';

@Injectable({
  providedIn: 'root',
})
export class AuthflowApiService {
  constructor(private readonly http: ApiClient) {}

  createAuthflow(): Observable<AuthflowResult> {
    return this.http
      .post<AuthflowEnvelope>('login/authflow', { type: 'login' })
      .pipe(map((env) => env.result));
  }

  getAuthflowState(stateToken: string): Observable<AuthflowResult> {
    return this.http
      .post<AuthflowEnvelope>('login/authflow/states', { stateToken })
      .pipe(map((env) => env.result));
  }

  submitInput(
    stateToken: string,
    input: Record<string, unknown>
  ): Observable<AuthflowResult> {
    return this.http
      .post<AuthflowEnvelope>('login/authflow/states/input', {
        stateToken,
        input,
      })
      .pipe(map((env) => env.result));
  }
}
